import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { TConfigSelect } from "..";
import { useMemo } from "react";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import { usePermission } from "../../../../../components/PermissionGuard";

export default function SideMenu({ select, handleSelect }: SideMenuProps) {

  const colorIcon = useMemo(() => "black", []);

  const options: TMenuList = [
     {
        label: "Boletos",
        icon: <AccountBalanceOutlinedIcon sx={{ color: colorIcon }} />,
        havePermission: usePermission("comercial.configuracoes"),
        disabled: false,
      },
      {
        label: "Categorias",
        icon: <CategoryOutlinedIcon sx={{ color: colorIcon }} />,
        havePermission: usePermission("comercial.categorias"),
        disabled: false,
      },
      {
        label: "Pedido configurações",
        icon: <AccountBalanceWalletOutlinedIcon sx={{ color: colorIcon }} />,
        havePermission: usePermission("comercial.configuracoes"),
        disabled: false,
      },
      {
        label: "Formas de Pagamento",
        icon: <PaymentsOutlinedIcon sx={{ color: colorIcon }} />,
        havePermission: usePermission('comercial.formas-pagamento'),
        disabled: true,
      },
      {
        label: "Consultores",
        icon: <EngineeringOutlinedIcon sx={{ color: colorIcon }} />,
        havePermission: usePermission('comercial.consultores'),
        disabled: false,
      },
      {
        label: "Promoções",
        icon: <CampaignOutlinedIcon sx={{ color: colorIcon }} />,
        havePermission: usePermission('comercial.promocoes'),
        disabled: false,
      },
    ]

  return (
    <>
      <List>
        {options.map((item, index) => {
          const itemSelecionado = item.label === select;

          if (!item.havePermission) return <></>;

          return (
            <ListItem
              disablePadding
              key={index}
              onClick={() => (!item.disabled ? handleSelect(item.label) : "")}
              sx={{ backgroundColor: itemSelecionado ? "#F0F0F0" : "unset" }}
            >
              <ListItemButton disabled={item.disabled}>
                <ListItemIcon>{item.icon}</ListItemIcon>

                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </>
  );
}

interface SideMenuProps {
  select: TConfigSelect;
  handleSelect: (arg: TConfigSelect) => void;
}

type TMenuList = Array<{
  label: TConfigSelect;
  icon: JSX.Element;
  havePermission: boolean;
  disabled: boolean;
}>;
